import { render, staticRenderFns } from "./list_of_reviews.vue?vue&type=template&id=6f8e4a32&scoped=true&"
import script from "./list_of_reviews.vue?vue&type=script&lang=js&"
export * from "./list_of_reviews.vue?vue&type=script&lang=js&"
import style0 from "./list_of_reviews.vue?vue&type=style&index=0&id=6f8e4a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e4a32",
  null
  
)

export default component.exports